import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

const { FiCheck } = FiIcons;

const Pricing = () => {
  const plans = [
    {
      name: "Starter",
      target: "For small businesses",
      price: "49",
      features: [
        "1 Location",
        "500 SMS Requests/mo",
        "Unlimited Email Requests",
        "Smart Feedback Filtering",
        "Review Monitoring"
      ],
      highlighted: false
    },
    {
      name: "Professional",
      target: "For growing businesses",
      price: "99",
      features: [
        "Up to 3 Locations",
        "2,000 SMS Requests/mo",
        "Unlimited Email Requests",
        "Smart Feedback Filtering",
        "Review Monitoring",
        "Custom Branding"
      ],
      highlighted: true
    },
    {
      name: "Unlimited",
      target: "For high-volume businesses",
      price: "199",
      features: [
        "Unlimited Locations",
        "Unlimited SMS Requests",
        "Unlimited Email Requests",
        "Full White-Label Dashboard",
        "API Access",
        "Dedicated Account Manager"
      ],
      highlighted: false
    }
  ];

  return (
    <div className="py-20 bg-slate-50">
      <div className="container px-4 mx-auto max-w-7xl">
        <div className="max-w-3xl mx-auto mb-16 text-center">
          <h1 className="mb-6 text-4xl font-bold md:text-5xl text-primary">Simple, transparent pricing.</h1>
          <p className="text-xl text-slate-600">Choose the plan that fits your business. All plans include a 14-day free trial.</p>
          <div className="inline-block px-4 py-2 mt-6 text-sm font-semibold rounded-full bg-accent/20 text-accent-hover">
            14-Day Free Trial — No Credit Card Required
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 max-w-6xl mx-auto">
          {plans.map((plan, idx) => (
            <div 
              key={idx} 
              className={`relative flex flex-col p-8 rounded-3xl ${
                plan.highlighted 
                  ? 'bg-primary text-white shadow-xl scale-105 z-10' 
                  : 'bg-white text-slate-900 shadow-soft border border-slate-100'
              }`}
            >
              {plan.highlighted && (
                <div className="absolute top-0 px-3 py-1 text-xs font-bold tracking-wider text-white transform -translate-x-1/2 -translate-y-1/2 rounded-full left-1/2 bg-secondary uppercase">
                  Most Popular
                </div>
              )}
              <div className="mb-8">
                <h3 className="mb-2 text-2xl font-bold">{plan.name}</h3>
                <p className={`text-sm ${plan.highlighted ? 'text-slate-300' : 'text-slate-500'}`}>{plan.target}</p>
              </div>
              <div className="mb-8">
                <span className="text-5xl font-extrabold">${plan.price}</span>
                <span className={`text-lg ${plan.highlighted ? 'text-slate-300' : 'text-slate-500'}`}>/mo</span>
              </div>
              <ul className="flex-grow mb-8 space-y-4">
                {plan.features.map((feature, fIdx) => (
                  <li key={fIdx} className="flex items-start gap-3">
                    <SafeIcon icon={FiCheck} className={`w-5 h-5 flex-shrink-0 mt-0.5 ${plan.highlighted ? 'text-secondary' : 'text-secondary'}`} />
                    <span className={plan.highlighted ? 'text-slate-200' : 'text-slate-600'}>{feature}</span>
                  </li>
                ))}
              </ul>
              <Button 
                to="/free-trial" 
                variant={plan.highlighted ? 'accent' : 'outline'} 
                fullWidth
                className={plan.highlighted ? 'text-primary' : ''}
              >
                Start Free Trial
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;